import React, { useState, useEffect } from 'react';
import { collection, query, where, getDocs, getFirestore } from 'firebase/firestore';

const db = getFirestore();

const MemberTransactionHistory = ({ memberEmail }) => {
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchTransactions = async () => {
            if (!memberEmail) return;
            setLoading(true);
            try {
                const q = query(
                    collection(db, "profiles"),
                    where("email", "==", memberEmail)
                );

                const querySnapshot = await getDocs(q);

                if (!querySnapshot.empty) {
                    const profileData = querySnapshot.docs[0].data();
                    const logs = profileData.transactionLogs || [];
                    const sortedLogs = [...logs].reverse();
                    setTransactions(sortedLogs);
                }
            } catch (error) {
                console.error("History Error:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchTransactions();
    }, [memberEmail]);

    const handlePrint = (tx) => {
        const printContents = `
            <div style="margin-bottom: 20px;">
                <p><strong>Date:</strong> ${tx.date}</p>
                <p><strong>Reference:</strong> ${tx.ref}</p>
                <p><strong>Type:</strong> ${tx.type}</p>
                <p><strong>Membership Type:</strong> ${tx.membershipType}</p>
                <p><strong>Note:</strong> ${tx.staffNote}</p>
                <p><strong>Amount:</strong> $${tx.amount}</p>
                <p><strong>Status:</strong> ${tx.status.toUpperCase()}</p>
                <p><strong>New Expiration Date:</strong> ${tx.newExpDate}</p>
            </div>
        `;
        const originalContents = document.body.innerHTML;
        document.body.innerHTML = `
            <div style="padding: 40px; font-family: sans-serif; color: #000; background: #fff;">
                <h2 style="text-align: center; border-bottom: 2px solid #333; padding-bottom: 10px;">ALBUQUERQUE PRESS CLUB</h2>
                <p style="text-align: center; font-size: 0.8rem;">Official Payment Receipt</p>
                ${printContents}
                <p style="margin-top: 50px; text-align: center; font-size: 0.7rem; opacity: 0.5;">
                    Thank you for supporting the APC. This is a computer-generated receipt.
                </p>
            </div>`;
        window.print();
        document.body.innerHTML = originalContents;
        window.location.reload();
    };

    if (loading) return <div className="text-center p-5 white-text">Loading History...</div>;

    return (
        <div className="mt-2 px-2 pb-5">
            <div className="d-flex align-items-center mb-3">
                <div className="bg-orange" style={{ width: '4px', height: '18px', marginRight: '8px' }}></div>
                <h4 className="auth-title m-0 blue" style={{ fontSize: '0.85rem', fontWeight: 'bold', letterSpacing: '2px'}}>
                    TRANSACTION LOGS
                </h4>
            </div>

            <div className="d-flex flex-column gap-3">
                {transactions.length === 0 ? (
                    <p className="white-text opacity-50 small">No transactions found in profile.</p>
                ) : (
                    transactions.map((tx, index) => (
                        <div key={tx.ref || index} className="glass-card p-3 rounded " style={{ border: '1px solid rgba(71, 71, 71, 0.21)' }}>
                            
                            {/* Top Row: Date and Print Button */}
                            <div className="d-flex justify-content-between align-items-start mb-2">
                                <div>
                                    <div className="orange fw-bold" style={{ fontSize: '1rem' }}>{tx.date}</div>
                                    <div className="text-info opacity-50" style={{ fontSize: '0.65rem' }}>REF: {tx.ref}</div>
                                </div>
                                <button onClick={() => handlePrint(tx)} className="btn btn-sm btn-outline-info border-0 p-0 opacity-75">
                                    <i className="bi bi-printer me-1"></i> PRINT
                                </button>
                            </div>

                            {/* Middle Box: Details */}
                            <div className="p-2 mb-2" style={{ background: 'rgba(255, 255, 255, 0.03)', borderRadius: '6px' }}>
                                <div className="d-flex justify-content-between align-items-center mb-1">
                                    <span className="grey" style={{ fontSize: '0.75rem' }}>Expires: {tx.newExpDate}</span>
                                    <span className="text-success fw-bold" style={{ fontSize: '0.65rem' }}>{tx.status.toUpperCase()}</span>
                                </div>
                                
                                <div className="small mb-1">
                                    <span className="blue opacity-75 d-block" style={{ fontSize: '0.7rem' }}>{tx.type} — {tx.membershipType}</span>
                                    {tx.staffNote && <span className="orange d-block mt-1 italic" style={{ fontSize: '0.75rem' }}>"{tx.staffNote}"</span>}
                                </div>
                            </div>

                            {/* Bottom Row: Total */}
                            <div className="d-flex justify-content-between align-items-center pt-2" style={{ borderTop: '1px dashed rgba(255,255,255,0.1)' }}>
                                <span className="green small fw-bold">TOTAL PAID</span>
                                <span style={{ color: '#0e8c21', fontSize: '1.1rem', fontWeight: '900' }}>${tx.amount}</span>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default MemberTransactionHistory;